module.exports = __webpack_public_path__ + "c8ddf1e5e5bf3682bc7bebf30f394148.woff";